import { __decorate, __metadata } from "tslib";
import { SensorValue } from './SensorValue';
import { SerializableObject } from '../decorators';
let Humidity = class Humidity extends SensorValue {
  constructor(value = 0) {
    super(value, undefined, undefined);
  }
  get value() {
    return this.x;
  }
  set value(x) {
    this.x = x;
  }
};
Humidity = __decorate([SerializableObject(), __metadata("design:paramtypes", [Object])], Humidity);
export { Humidity };